import React from "react";
import { Wrench, FileText, List, Clock, Tag } from "lucide-react";
import { cn } from "views/lib/utils";

const AdminSidebar = ({ activeTab, onTabChange, stats }) => {
    const navItems = [
        {
            id: "tools",
            label: "Tools",
            icon: Wrench,
            tabs: [
                { id: "all", label: "All Tools" },
                {
                    id: "pending",
                    label: "Pending Review",
                    count: stats?.pending,
                },
                { id: "approved", label: "Approved", count: stats?.approved },
                { id: "rejected", label: "Rejected", count: stats?.rejected },
                { id: "error", label: "Processing Error", count: stats?.error },
                { id: "queue", label: "Processing Queue" },
                { id: "submit", label: "Submit Tool" },
                { id: "batch-submit", label: "Batch Submit Tools" },
                { id: "batch-mcp-submit", label: "Batch Submit MCPs" },
                { id: "url-crawler", label: "URL Crawler" },
            ],
        },
        {
            id: "blog",
            label: "Blog",
            icon: FileText,
            tabs: [
                { id: "blog", label: "Blog Posts" },
                { id: "blog-titles", label: "Blog Titles" },
            ],
        },
        {
            id: "categories",
            label: "Categories",
            icon: Tag,
            tabs: [{ id: "categories", label: "Category Management" }],
        },
    ];

    return (
        <div className="w-64 bg-white border-r h-screen fixed left-0 top-0 pt-16">
            <nav className="p-4 space-y-6">
                {navItems.map((item) => (
                    <div key={item.id} className="space-y-2">
                        <div className="flex items-center gap-2 px-2 py-1 text-sm font-medium text-gray-500">
                            <item.icon className="h-4 w-4" />
                            {item.label}
                        </div>
                        <div className="space-y-1">
                            {item.tabs.map((tab) => (
                                <button
                                    key={tab.id}
                                    onClick={() => onTabChange(tab.id)}
                                    className={cn(
                                        "w-full text-left px-4 py-2 text-sm rounded-md transition-colors flex items-center justify-between",
                                        activeTab === tab.id
                                            ? "bg-blue-50 text-blue-700"
                                            : "text-gray-600 hover:bg-gray-50"
                                    )}
                                >
                                    <span>{tab.label}</span>
                                    {tab.count !== undefined && (
                                        <span
                                            className={cn(
                                                "px-2 py-0.5 text-xs rounded-full",
                                                activeTab === tab.id
                                                    ? "bg-blue-100 text-blue-700"
                                                    : "bg-gray-100 text-gray-600"
                                            )}
                                        >
                                            {tab.count}
                                        </span>
                                    )}
                                </button>
                            ))}
                        </div>
                    </div>
                ))}
            </nav>
        </div>
    );
};

export default AdminSidebar;
